import * as types from './action-types';

export const ignoreLocalStorage = true;

export const DEFAULT_STATE = {
    error: null,
    hasError: false,
    pending: false,
    ignoreLocalStorage,
};

const reducer = (state={}, action) => {
    const returnState = Object.assign({}, DEFAULT_STATE, state);

    switch (action.type) {
    case types.CUSTOMIZE_OFFERS_PENDING:
        return Object.assign(returnState, {
            error: null,
            hasError: false,
            pending: true,
        });

    case types.CUSTOMIZE_OFFERS_FAILED:
        return Object.assign(returnState, {
            error: action.error,
            hasError: true,
            pending: false,
        });

    case types.CUSTOMIZE_OFFERS_SUCCESS:
        return Object.assign(returnState, {
            error: null,
            hasError: false,
            pending: false,
        });

    default:
        return returnState;
    }
};

export default reducer;
